<template lang="pug">
.cp-product-list1
  .list-wrap.w
    .item(v-for="v in list")
      icon.icon(:iconClass="v.iconClass")
      p {{ v.label }}
      p {{ v.content }}
</template>
<script>
export default {
  components: {},
  props: {
    type: {
      default: 'dmp',
      type: String
    }
  },
  computed: {
    list () {
      return this.product[this.type] || []
    }
  },
  data () {
    return {
      product: {
        dmp: [
          { iconClass: 'iconduoshujuyuan', label: '多数据源', content: '公私域一体的数据采集和应用,能够快速连接各种类型的数据源中存储的客户数据' },
          { iconClass: 'iconduoweibiaoqian', label: '多维标签', content: '根据业务自定义条件，将收集到的零散的客户特征、行为数据转译成标签，最终形成客户画像' },
          { iconClass: 'iconkehuhuaxiang', label: '客户画像', content: '连接企业所有客户触点，构建全景客户画像，及时洞察客情、构建个性化客户互动体验' },
          { iconClass: 'iconjingzhunfenqun', label: '精准分群', content: '预置生命周期标签，叠加组合多维度标签精准分群，快速圈选目标客户群体' },
          { iconClass: 'iconbaobiaofenxi', label: '报表分析', content: '丰富多样的数据分析模型，支持灵活自定义报表体系，大幅提升分析效率' },
          { iconClass: 'icontongyishitu', label: '统一视图', content: '将分散的数据源统一到单个主数据集中，从而提供该数据的统一视图，做到对客户的全面认知' },
        ],
        mp: [
          { iconClass: 'iconfugaiguang', label: '覆盖全面', content: '覆盖移动、联通、电信三大运营商场景，精准触达客户' },
          { iconClass: 'icondanxingshiyong', label: '弹性吞吐', content: '根据业务需求弹性进线，柔性可用，支持突发事务' },
          { iconClass: 'iconzhinengdaduan', label: '智能打断', content: '四种打断模式智能选择，还原真实对话场景' },
          { iconClass: 'iconyuanshengcaiyang', label: '原声采样', content: '专业发言人原声采样，声音甜美，完美拟真' },
          { iconClass: 'iconwuganzhuanjie', label: '无感转接', content: '通话插话监听，意向客户智能无感转接，一手商机不容错过' },
          { iconClass: 'iconhouzhiyewuzhuanhua', label: '空中转化', content: '挂机后自动发送短信，业务后置处理，语音互动不白忙' },
        ]
      },
    }
  }

}
</script>
<style lang="stylus">
.cp-product-list1
  position relative
  background url('../../../assets/jianbiandi.png') center / 100% no-repeat
  background-size: cover;
  .list-wrap
    padding 60px 60px 0
    display flex
    flex-wrap wrap
    justify-content space-between
    .item
      width 260px
      margin-bottom 80px
      text-align center
      .icon
        font-size 58px
      &:nth-child(3n+2)
        margin 0 140px
      p
        &:nth-child(2)
          font-size 24px
          font-weight 600
          margin-top 25px
          margin-bottom 10px
        &:last-child
          font-size 16px
          color #F4F5F7
          text-align center
</style>
